module.exports = __webpack_public_path__ + "img/20190824114746360截图20190822215108753.e523f0ae.jpg";